module.exports = __webpack_public_path__ + "img/24.268ded5c.png";